import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertCard } from "./AlertCard";
const railStyle = {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    backgroundColor: "var(--color-pure-white)",
    borderLeft: "1px solid var(--color-pebble)",
};
const headerStyle = {
    display: "flex",
    alignItems: "center",
    // Only the "N ACTIVE" pill remains — RailCarousel already owns the
    // "Bunching · N" title + "Alert rail" kicker at the slide-header
    // level, so duplicating them here produced a doubled heading inside
    // a single carousel slide. Keep the status pill right-aligned.
    justifyContent: "flex-end",
    padding: "12px 20px",
    borderBottom: "1px solid var(--color-pebble)",
};
const stackStyle = {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    padding: 20,
    overflowY: "auto",
    flex: "1 1 auto",
};
function emptyMessage(connectionState) {
    switch (connectionState) {
        case "disconnected":
            return "Backend unreachable — waiting to reconnect.";
        case "connecting":
            return "Connecting to control tower…";
        case "polling":
            return "No bunching forecasts on Route AS-4.";
        case "connected":
        default:
            return "No bunching forecasts on Route AS-4.";
    }
}
export function BunchingRail({ alerts, connectionState, onHold, onDismiss, }) {
    // ONE clay card per viewport rule (design.md §6.7 + hallmark §6):
    // only the FIRST active alert renders in clay; others stay white.
    let clayUsed = false;
    const rendered = alerts.map((alert) => {
        const isActive = alert.displayState === "active";
        const variant = isActive && !clayUsed ? (clayUsed = true, "clay") : "white";
        return (_jsx(AlertCard, { alert: alert, variant: variant, onHold: onHold, onDismiss: onDismiss }, alert.id));
    });
    const activeCount = alerts.filter((a) => a.displayState === "active").length;
    return (_jsxs("aside", { style: railStyle, "data-testid": "bunching-rail", "aria-label": "Bunching alerts", children: [_jsx("div", { style: headerStyle, children: _jsxs("div", { style: {
                        padding: "6px 10px",
                        border: "1px solid var(--color-pebble)",
                        borderRadius: 1000,
                        fontSize: 12,
                        fontWeight: 700,
                        letterSpacing: "0.08em",
                        textTransform: "uppercase",
                        color: activeCount > 0 ? "var(--color-clay-ember)" : "var(--color-cool-ash)",
                    }, children: [activeCount, " active"] }) }), _jsx("div", { style: stackStyle, children: rendered.length === 0 ? (_jsx("div", { "data-testid": "alerts-empty", style: {
                        fontSize: 15,
                        lineHeight: 1.5,
                        color: "var(--color-cool-ash)",
                        padding: 24,
                        border: "1px dashed var(--color-pebble)",
                        textAlign: "center",
                    }, children: emptyMessage(connectionState) })) : (rendered) })] }));
}
